import React from "react";

import { dummyArchiveMetadataService } from "@/api/services/implementations";
import { ArchiveMetadataService } from "@/api/services/interfaces";


export const ArchiveMetadataContext = React.createContext<ArchiveMetadataService>(dummyArchiveMetadataService);
export const ArchiveMetadataProvider = ArchiveMetadataContext.Provider;
export const ArchiveMetadataConsumer = ArchiveMetadataContext.Consumer;

interface Props {
    service: ArchiveMetadataService;
}

export const ArchiveMetadataContextWrapper: React.FC<Props> = ({ service, children }) => {
    return <ArchiveMetadataProvider value={service}>{children}</ArchiveMetadataProvider>;
};
